import { ReactNode } from "react";
import cn from "classnames";
import { useParams, useNavigate } from "react-router";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";

import { HeaderProps, BackButton } from "@/basic/components";
import { StickyLayout } from "@/basic/layouts";

import { ALLOW_FORMULARY_LIST } from "@/basic/constants/allowClientList";
import { useCheckCurrentScreen } from "@/basic/hooks";
import { FormularyParams } from "@/basic/components/FormularyButtonContainer";

import styles from "./styles.module.scss";

export interface PharmacyJourneyLayoutProps extends HeaderProps {
  children: ReactNode;
  testId?: string;
  topSectionContent?: ReactNode;
  backButtonParams?: string;
  backButtonUrl?: string;
  detailsPage?: boolean;
}

export interface params {
  formulary: string;
}

export const PharmacyJourneyLayout = ({
  children,
  testId,
  topSectionContent,
  backButtonParams,
  backButtonUrl,
  detailsPage = false,
}: PharmacyJourneyLayoutProps) => {
  const navigate = useNavigate();
  const { formulary }: FormularyParams = useParams();

  const screen = useCheckCurrentScreen();
  const wideScreen = screen === "desktop";

  const PharmacyJourneyLayoutClass = cn(styles["HeaderWrapper"]);

  const topSectionClass = cn(styles["TopSection"], { [styles["TopSectionDetailsPage"]]: detailsPage });

  const topSectionInnerClass = cn(styles["PharmacyJourneyContentWrapper"], { [styles["noPadding"]]: !wideScreen });

  if (!Object.prototype.hasOwnProperty.call(ALLOW_FORMULARY_LIST, formulary)) {
    navigate("/404");
  }

  return (
    <StickyLayout logoAlignment="left" testId={testId} noSpacing className={PharmacyJourneyLayoutClass}>
      <>
        <div className={topSectionClass} data-testid="top-section">
          <div className={topSectionInnerClass}>
            <Stack>
              {backButtonUrl && (
                <Shelf>
                  <BackButton path={backButtonUrl} params={backButtonParams} />
                  <Shelf.Spacer />
                </Shelf>
              )}

              {topSectionContent}
            </Stack>
          </div>
        </div>
        <div className={styles["PharmacyJourneyWrapper"]}>{children}</div>
      </>
    </StickyLayout>
  );
};
